import { BrowserRouter as Router } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { LoadingProvider } from "./context/LoadingContext";
import { CountsProvider } from "./context/CountsContext"; 
import { Toaster } from "react-hot-toast";
import AppRoutes from "./routes/Routes";

function App() {
  return (
    <LoadingProvider>
      <AuthProvider>
        <CountsProvider>
          <Toaster position="top-right" reverseOrder={false} />
          <Router>
            <AppRoutes />
          </Router>
        </CountsProvider>
      </AuthProvider>
    </LoadingProvider>
  );
}

export default App;